import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog } from "./dialogSlice";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Ripple } from "@progress/kendo-react-ripple";
import { RootState } from "../../app/store";
import { IAppDialog } from "./dialogModel";
import { RxCross1 } from "react-icons/rx";

type themeColor =
  | "primary"
  | "base"
  | "secondary"
  | "tertiary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "dark"
  | "light"
  | "inverse";

export const DialogCloseButton: React.FC<{
  text?: string;
  themeColor?: themeColor;
  isCrossSign?: boolean;
}> = ({ text = "Close", themeColor = "primary", isCrossSign = false }) => {
  const dispatch = useAppDispatch();
  return (
    <Ripple>
      <Button
        fillMode={isCrossSign ? "solid" : "outline"}
        themeColor={themeColor}
        type="button"
        onClick={() => dispatch(closeDialog())}
        style={
          isCrossSign
            ? { width: 35, height: 35, position: "relative" }
            : { marginRight: 4 }
        }
      >
        {isCrossSign ? <RxCross1 style={{ marginLeft: 2 }} /> : text}
      </Button>
    </Ripple>
  );
};

const AppDialog: React.FC<IAppDialog> = (props) => {
  const dispatch = useAppDispatch();
  const open = useAppSelector((state: RootState) => state.dialog.open);

  return (
    <>
      {open && (
        <Dialog
          onClose={() => dispatch(closeDialog())}
          className="main-dialog-contaner"
        >
          {props.children}
        </Dialog>
      )}
    </>
  );
};

export default AppDialog;
